module.exports = __webpack_public_path__ + "img/logo-dark.4e0bca83.png";